export const EditIcon = (props) => (
  <svg
    {...props}
    height={props?.height || '16'}
    width={props?.width || '16'}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1753_39559)">
      <path
        d="M7.3335 2.66421H2.66683C2.31321 2.66421 1.97407 2.80469 1.72402 3.05474C1.47397 3.30479 1.3335 3.64392 1.3335 3.99755V13.3309C1.3335 13.6845 1.47397 14.0236 1.72402 14.2737C1.97407 14.5237 2.31321 14.6642 2.66683 14.6642H12.0002C12.3538 14.6642 12.6929 14.5237 12.943 14.2737C13.193 14.0236 13.3335 13.6845 13.3335 13.3309V8.66421M12.3335 1.66421C12.5987 1.399 12.9584 1.25 13.3335 1.25C13.7086 1.25 14.0683 1.399 14.3335 1.66421C14.5987 1.92943 14.7477 2.28914 14.7477 2.66421C14.7477 3.03929 14.5987 3.399 14.3335 3.66421L8.00016 9.99755L5.3335 10.6642L6.00016 7.99755L12.3335 1.66421Z"
        stroke={props?.color || '#344054'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1753_39559">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
